"use client";

import { BadgeCheck, FileText, Lock, RefreshCw } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const trustItems = [{
  title: "Data Resmi & Terverifikasi",
  description: "Setiap informasi berasal dari dokumen resmi organisasi dan telah diverifikasi.",
  icon: BadgeCheck
}, {
  title: "Sumber Terpercaya",
  description: "Bersumber dari SK, arsip resmi, buku sejarah, dan dokumen MPN / MPW / MPC.",
  icon: FileText
}, {
  title: "Privasi Terjaga",
  description: "Data sensitif tidak ditampilkan publik dan dikelola sesuai kebijakan organisasi.",
  icon: Lock
}, {
  title: "Perubahan Data",
  description: "Jika ada koreksi atau pembaruan data, silakan hubungi admin wilayah.",
  icon: RefreshCw
}];
export default function OrganizationalTrustBar() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section id="organizationaltrustbar" className="bg-background border-t border-border py-10 lg:py-12">
      <div ref={ref} className={`container mx-auto px-4 md:px-6 transition-all duration-700 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-0">
          {trustItems.map((item, i) => <div key={i} data-index={i} className="flex items-start gap-4 lg:px-6 lg:border-r lg:border-border last:lg:border-r-0 first:lg:pl-0 last:lg:pr-0">
              <div className="shrink-0 text-primary bg-primary/10 p-3 rounded-lg">
                <item.icon className="size-6 md:size-8" strokeWidth={1.5} />
              </div>
              <div className="flex flex-col gap-1">
                <h3 className="font-default font-semibold text-foreground text-base md:text-lg leading-tight">
                  {item.title}
                </h3>
                <p className="text-sm text-muted-foreground leading-relaxed">
                  {item.description}
                </p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}